import { useEffect, useRef } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { ScrollContext } from "./context/ScrollContext";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import EditorialMarquee from "./components/EditorialMarquee";
import ServicesSection from "./components/ServicesSection";
import PricingSection from "./components/PricingSection";
import BioSection from "./components/BioSection";
import ServiceAreaSection from "./components/ServiceAreaSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  const scrollTo = (target) => {
    if (lenisRef.current) {
      lenisRef.current.scrollTo(target, { offset: -72, duration: 1.5 });
    }
  };

  return (
    <ScrollContext.Provider value={{ scrollTo }}>
      <div className="min-h-screen bg-[#FBFAF7] text-[#2B1B45] font-sans antialiased overflow-x-clip">
        <div className="grain-overlay" />
        <Header />
        <main>
          <HeroSection />
          <EditorialMarquee />
          <ServicesSection />
          <PricingSection />
          <BioSection />
          <ServiceAreaSection />
          <ContactSection />
        </main>
        <Footer />
        <Toaster position="bottom-right" richColors closeButton />
      </div>
    </ScrollContext.Provider>
  );
}

export default App;
